import { supabase } from "../supabaseClient";
import { getCurrentDpaVersion } from "../config/dpaConfig";

/**
 * Get DPA acceptance status for an organization
 * @param {string} organizationId - Organization ID
 * @returns {Promise<Object>} - DPA status object
 */
export const getOrganizationDpaStatus = async (organizationId) => {
  if (!organizationId) return null;

  try {
    const currentVersion = getCurrentDpaVersion();
    const { data, error } = await supabase.rpc("get_organization_dpa_status", {
      organization_id: organizationId,
      dpa_version: currentVersion,
    });

    if (error) {
      console.error("Error getting DPA status:", error);
      // If database function doesn't exist, return null (component will handle gracefully)
      return null;
    }

    return data;
  } catch (error) {
    console.error("Error getting DPA status:", error);
    // Return null to indicate status unavailable
    return null;
  }
};
